(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4088],{

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 42862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ RemoteworktownPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
;// CONCATENATED MODULE: ./src/components/pages/Remoteworktown/Detailed/style.tsx

var MiyawakaNav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "style__MiyawakaNav",
  componentId: "sc-trxqha-0"
})(["max-width:800px;padding:0px 0;margin:0 auto;.miyawaka-nav__desc{line-height:1.8;margin:20px auto;}.miyawaka-nav__list{display:flex;align-items:center;justify-content:center;margin:50px auto 0;}.miyawaka-nav__list-item{min-width:50px;}.miyawaka-nav__list-item-link{display:flex;width:200px;height:80px;position:relative;flex-flow:column;justify-content:center;align-items:center;cursor:pointer;color:#ffffff;background-color:#4B4B4B;border-radius:8px;margin:0 8px;.miyawaka-nav:hover{color:#e20000;}}.miyawaka-nav__list-item-link:hover{opacity:0.9;}.miyawaka-nav__list-item-link:after{content:url('data:image/svg+xml;base64,PHN2ZyB0PSIxNzI0Mjg5NDExNzQyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQyNTIiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTg5MC4zMzUzODUgMzMwLjkxMTIyMmMtMTIuNTc2Mzc0LTEyLjQxNjM5Ni0zMi44MDA3NTMtMTIuMzUyNzQ4LTQ1LjI0ODExMiAwLjE5MjY2Mkw1MTcuMjQ4MzI3IDY2MS45NTE0NTggMTg0LjgzMTkzMSAzMzIuNTEyNzI3Yy0xMi41NzYzNzQtMTIuNDQ3MzU5LTMyLjgwMDc1My0xMi4zNTI3NDgtNDUuMjgwNzk2IDAuMTkyNjYyLTEyLjQ0NzM1OSAxMi41NzYzNzQtMTIuMzUyNzQ4IDMyLjgzMTcxNiAwLjE5MjY2MiA0NS4yODA3OTZsMzUzLjMxMTY1MiAzNTAuMTEyMDgyYzAuNTQzNTgzIDAuNTQzNTgzIDEuMjQ3MTQ0IDAuNjcyNTk4IDEuNzkyNDQ3IDEuMTgzNDk3IDAuMTI3Mjk1IDAuMTI3Mjk1IDAuMTU5OTc4IDAuMjg3MjczIDAuMjg3MjczIDAuNDE2Mjg4IDYuMjM5MTYxIDYuMTc1NTE0IDE0LjM5OTc4NSA5LjI4MDQ3MyAyMi41Mjc3MjUgOS4yODA0NzMgOC4yMjQyNzEgMCAxNi40Nzk1MDUtMy4xNjg2MDYgMjIuNzIwMzg3LTkuNDcxNDE1bDM1MC4xMTIwODItMzUzLjMxMTY1MkM5MDIuOTc1NDA3IDM2My42MTU2NDMgOTAyLjg4MDc5NiAzNDMuMzYwMzAxIDg5MC4zMzUzODUgMzMwLjkxMTIyMnoiIGZpbGw9IiNmZmZmZmYiIHAtaWQ9IjQyNTMiPjwvcGF0aD48L3N2Zz4=');position:absolute;bottom:5px;}@media screen and (max-width:1047px){.miyawaka-nav__list{flex-direction:column;}.miyawaka-nav__list-item-link{height:70px;font-size:16px;margin-bottom:20px;}&>img{width:100%;margin:20px auto;}}"]);
var Main = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
  displayName: "style__Main",
  componentId: "sc-trxqha-1"
})([".miyawaka-intro__img{min-height:300px;width:100vw;padding:60px 112px;margin:0 calc(50% - 50vw);background-image:url(/images/remoteworktown_bg_pc.jpeg);background-repeat:no-repeat;background-position:top center;background-size:cover;text-align:center;}.miyawaka-intro__movie-block{margin:80px auto 0;max-width:1000px;padding:40px;background-color:#dcdcdc;border:1px solid #ccc;}.miyawaka-intro__movie{width:100%;height:500px;}.miyawaka-intro__movie-item + .miyawaka-intro__movie-item{margin-top:20px;}.miyawaka-intro__movie-title{margin-top:10px;font-size:24px;font-weight:bold;color:#033b7a;}.miyawaka-news{max-width:1000px;margin:80px auto 0;}.miyawaka-news__title{font-size:40px;text-align:center;}.miyawaka-news__list{margin-top:80px;display:flex;flex-wrap:wrap;}.miyawaka-three-column{margin-top:50px;display:flex;}.miyawaka-three-column__item{margin-right:20px;width:33.3%;}.miyawaka-three-column__item:last-child{margin-right:0;}.miyawaka-three-column__title{margin-top:10px;width:100%;font-size:20px;color:#20307e;line-height:1.6;font-weight:400;text-align:center;border-bottom:2px solid #20307e;letter-spacing:-1px;}.miyawaka-three-column__text{margin-top:10px;font-size:16px;line-height:2;}.miyawaka-three-column__text-title{font-weight:bold;margin-top:5px;line-height:1.5;}.miyawaka-three-column__img{width:300px;height:200px;}.miyawaka-concept{max-width:1000px;margin:80px auto 0;}.miyawaka-concept__title{font-size:40px;text-align:center;margin-bottom:80px;}.miyawaka-concept__block + .miyawaka-concept__block{margin-top:120px;}.miyawaka-concept__block-title-wrapper{display:flex;align-items:baseline;}.miyawaka-concept__icon{width:120px;height:30px;margin-right:30px;}.miyawaka-concept__block-title{font-size:40px;line-height:1.6;font-weight:400;letter-spacing:-2.4px;}.miyawaka-concept__block-title-sub{display:block;font-size:24px;}.miyawaka-concept__block-text{margin-top:30px;font-size:16px;line-height:2;}.miyawaka-concept__img-wrapper{margin-top:20px;text-align:center;}.miyawaka-concept__img{width:660px;}.miyawaka-concept__change{margin-top:20px;display:flex;}.miyawaka-concept__change-img{position:relative;}.miyawaka-concept__change-img + .miyawaka-concept__change-img{margin-left:20px;}.miyawaka-concept__change-img:hover .miyawaka-concept__img-caption{height:0;}.miyawaka-concept__img-caption{position:absolute;bottom:0;left:0;width:100%;height:60px;text-align:center;color:#fff;background:rgba(0,0,0,0.6);transition:height 0.6s;}.miyawaka-concept__img-caption-title{font-size:13px;font-weight:bold;}.miyawaka-concept__img-caption-name{font-size:16px;}.miyawaka-concept__img-caption-name--narrow{font-size:16px;letter-spacing:-1px;}.miyawaka-concept__change-note{position:relative;}.miyawaka-facility{max-width:1000px;margin:80px auto 0;}.miyawaka-facility__title{font-size:40px;text-align:center;}.miyawaka-facility__img{margin-top:80px;text-align:center;img{width:100%;}}.facility-table-scroll-hint{display:none;}.facility-table-wrapper{margin-top:40px;}.facility-table{width:100%;border-collapse:collapse;}.facility-table__row{border-bottom:solid 2px #49b132;height:70px;}.facility-table__head,.facility-table__foot{color:#fff;background:#49b132;padding:15px 0;text-align:center;}.facility-table__data{padding:15px 0;text-align:center;line-height:1.4;vertical-align:middle;}.facility-table__data--small{font-size:11px;}.facility-table .facility-table__number1,.facility-table .facility-table__number2,.facility-table .facility-table__number3,.facility-table .facility-table__number4,.facility-table .facility-table__number5,.facility-table .facility-table__number6,.facility-table .facility-table__number7,.facility-table .facility-table__number8,.facility-table .facility-table__number9{position:relative;padding:15px 0 15px 40px;text-align:center;line-height:1.4;vertical-align:middle;}.facility-table .facility-table__number1::before,.facility-table .facility-table__number2::before,.facility-table .facility-table__number3::before,.facility-table .facility-table__number4::before,.facility-table .facility-table__number5::before,.facility-table .facility-table__number6::before,.facility-table .facility-table__number7::before,.facility-table .facility-table__number8::before,.facility-table .facility-table__number9::before{position:absolute;left:0;top:50%;transform:translateY(-50%);display:inline-block;content:'';width:40px;height:40px;background-repeat:no-repeat;}.facility-table__number1::before{background-image:url(/images/remoteworktown_no01.svg);}.facility-table__number2::before{background-image:url(/images/remoteworktown_no02.svg);}.facility-table__number3::before{background-image:url(/images/remoteworktown_no03.svg);}.facility-table__number4::before{background-image:url(/images/remoteworktown_no04.svg);}.facility-table__number5::before{background-image:url(/images/remoteworktown_no05.svg);}.facility-table__number6::before{background-image:url(/images/remoteworktown_no06.svg);}.facility-table__number7::before{background-image:url(/images/remoteworktown_no07.svg);}.facility-table__number8::before{background-image:url(/images/remoteworktown_no08.svg);}.facility-table__number9::before{background-image:url(/images/remoteworktown_no09.svg);}.miyawaka-links{max-width:1000px;margin:80px auto 0;text-align:center;}.miyawaka-links__title{font-size:40px;text-align:center;}.miyawaka-links__main{margin-top:80px;display:flex;justify-content:center;}.miyawaka-links__link-item + .miyawaka-links__link-item{margin-left:80px;}.miyawaka-links__img-link{display:block;padding-bottom:20px;border-bottom:2px solid #ececec;img{max-width:100%;}}.miyawaka-links__img-link:hover{opacity:0.7;}.miyawaka-links__img{width:213px;height:77px;}.miyawaka-links__link{display:block;margin-top:20px;text-decoration:none;color:#30a8fb;font-weight:700;}.miyawaka-links__link:hover{text-decoration:underline;}.miyawaka-links__group{margin-top:80px;}.miyawaka-links__group-title{font-size:24px;font-weight:400;}.miyawaka-links__group-link-list{margin-top:30px;padding-left:24px;line-height:1.8;}.miyawaka-links__group-link-item{list-style:none;}.miyawaka-links__group-link{text-decoration:none;color:#30a8fb;font-size:16px;}.miyawaka-links__group-link:hover{text-decoration:underline;}.miyawaka-conclusion{max-width:1000px;margin:120px auto 0;}.miyawaka-conclusion__img{text-align:center;img{max-width:100%;}}@media screen and (max-width:1047px){.miyawaka-intro__img{min-height:none;padding:40px 24px;}.miyawaka-intro__movie-block{padding:30px 24px;}.miyawaka-intro__movie{height:62.5vw;}.miyawaka-intro__movie-title{font-size:20px;line-height:1.4;}.miyawaka-news{margin-top:60px;}.miyawaka-news__title{font-size:24px;}.miyawaka-news__list{flex-direction:column;}.miyawaka-concept{margin-top:60px;}.miyawaka-concept__title{font-size:24px;margin-bottom:60px;}.miyawaka-concept__block-title-wrapper{flex-direction:column;}.miyawaka-concept__block-title{font-size:24px;margin-top:10px;line-height:1.3;}.miyawaka-concept__block-title-sub{font-size:20px;margin-top:10px;}.miyawaka-concept__block-text{line-height:1.8;}.miyawaka-concept__img{width:100%;}.miyawaka-concept__change{flex-direction:column;align-items:center;}.miyawaka-concept__change-img{max-width:300px;}.miyawaka-concept__change-img + .miyawaka-concept__change-img{margin-left:0;margin-top:20px;}.miyawaka-concept__img-caption-name{font-size:1.5rem;}.miyawaka-concept__img-caption-name--narrow{font-size:1.4rem;}.miyawaka-concept__change-note{font-size:1.5rem;text-align:center;}.miyawaka-three-column{flex-direction:column;align-items:center;}.miyawaka-three-column__item{display:flex;justify-content:center;align-items:center;flex-direction:column;width:100%;margin-right:0;}.miyawaka-three-column__item + .miyawaka-three-column__item{margin-top:30px;}.miyawaka-three-column_text{margin-left:0;}.miyawaka-three-column__text-title{margin-top:10px;font-size:16px;line-height:2;font-weight:bold;}.miyawaka-three-column__img{max-width:300px;width:100%;}.miyawaka-facility{margin-top:60px;}.miyawaka-facility__title{font-size:2.6rem;}.facility-table-wrapper{width:100%;overflow-x:scroll;white-space:nowrap;}.facility-table-wrapper::-webkit-scrollbar{height:5px;}.facility-table-wrapper::-webkit-scrollbar-track{background:#f1f1f1;}.facility-table-wrapper::-webkit-scrollbar-thumb{background:#bcbcbc;}.facility-table-scroll-hint{display:block;font-size:14px;margin-bottom:10px;}.facility-table{font-size:14px;}.facility-table__head{padding:15px;}.facility-table .facility-table__number1,.facility-table .facility-table__number2,.facility-table .facility-table__number3,.facility-table .facility-table__number4,.facility-table .facility-table__number5,.facility-table .facility-table__number6,.facility-table .facility-table__number7,.facility-table .facility-table__number8,.facility-table .facility-table__number9{padding:15px 15px 15px 40px;vertical-align:middle;}.facility-table .facility-table__number1::before,.facility-table .facility-table__number2::before,.facility-table .facility-table__number3::before,.facility-table .facility-table__number4::before,.facility-table .facility-table__number5::before,.facility-table .facility-table__number6::before,.facility-table .facility-table__number7::before,.facility-table .facility-table__number8::before,.facility-table .facility-table__number9::before{width:30px;height:30px;}.facility-table__data{padding:15px 15px;}.miyawaka-links{margin-top:60px;}.miyawaka-links__title{font-size:24px;}.miyawaka-links__main{flex-direction:column;}.miyawaka-links__link-item{text-align:left;}.miyawaka-links__link-item + .miyawaka-links__link-item{margin-left:0;margin-top:55px;}.miyawaka-links__img{max-width:435px;width:auto;height:auto;}.miyawaka-links__link{font-size:16px;}.miyawaka-links__group{margin-top:40px;}.miyawaka-links__group-title{font-size:2rem;}.miyawaka-conclusion{margin-top:60px;border-top:dotted 2px #999;padding-top:40px;}.c-item{padding:0 0 20px 20px;width:100%}.c-item:nth-child(n+2){margin-top:30px}.c-item-info{font-size:14px !important;}.c-item-title{font-size:14px !important;}}"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Remoteworktown/Detailed/topicItem.tsx



function TopicItem(_ref) {
  var topic = _ref.topic;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
    className: "c-item",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "c-item-info-row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "c-item-info",
        children: topic.publishDate.substring(0, 10)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "c-item-info",
        children: topic.category.name
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: topic.file.src,
      target: "_blank",
      rel: "noreferrer noopener",
      className: "c-item-title",
      children: topic.title
    }), topic.isImportant && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "c-item-important",
      children: "\u91CD\u8981\u306A\u304A\u77E5\u3089\u305B"
    })]
  });
}
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "topicItem__Item",
  componentId: "sc-jxyyqb-0"
})(["width:33.3%;padding:0 90px 20px 20px;border-left:4px solid #181e26;&:nth-child(n + 4){margin-top:60px;}.c-item-info-row{display:flex;}.c-item-info{font-size:14px;color:#999;&:first-child::after{display:inline-block;content:'\uFF5C';margin:0 8px;color:#999;}}.c-item-title{display:inline-block;margin-top:12px;text-decoration:none;color:#30a8fb;font-size:16px;line-height:1.5;&:hover{text-decoration:underline;}}.c-item-important{display:block;color:#fff;background-color:#e20000;padding:2px 10px;border-radius:3px;font-size:12px;margin-top:12px;width:fit-content;}@media screen and (max-width:1047px){.c-item{width:100%;padding:0 0 20px 20px;&:nth-child(n + 2){margin-top:30px;}}.c-item-info{font-size:1.3rem;}.c-item-title{font-size:1.5rem;}}"]);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
;// CONCATENATED MODULE: ./src/components/pages/Remoteworktown/Detailed/index.tsx







var Detailed = function Detailed(_ref) {
  var topics = _ref.topics;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MiyawakaNav, {
      className: "miyawaka-nav",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "/images/remoteworktown_kv.png",
        alt: ""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "miyawaka-nav__desc",
        children: "\u798F\u5CA1\u5E02\u3068\u5317\u4E5D\u5DDE\u5E02\u306E\u307B\u307C\u4E2D\u9593\u306B\u4F4D\u7F6E\u3059\u308B\u5BAE\u82E5\u5E02\u3002\u3053\u306E\u5730\u3067\u3001\u65B0\u3057\u3044\u307E\u3061\u3065\u304F\u308A\u304C\u59CB\u307E\u3063\u3066\u3044\u307E\u3059\u3002\u3053\u306E\u30DA\u30FC\u30B8\u3067\u306F\u3001\u5E02\u6C11\u30FB\u884C\u653F\u30FB\u6C11\u9593\u4E8B\u696D\u8005\u304C\u5354\u50CD\u3057\u3066\u958B\u8A2D\u3059\u308B\u56FD\u5185\u521D\u306E\u30EA\u30C6\u30FC\u30EBAI\u958B\u767A\u62E0\u70B9\u300C\u30EA\u30E2\u30FC\u30C8\u30EF\u30FC\u30AF\u30BF\u30A6\u30F3\u30E0\u30B9\u30D6\u5BAE\u82E5\u300D\u306E\u69CB\u60F3\u3084\u9032\u6357\u7B49\u306B\u3064\u3044\u3066\u304A\u77E5\u3089\u305B\u3057\u3066\u3044\u304D\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "miyawaka-nav__list",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "miyawaka-nav__list-item",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(modules/* Link */.rU, {
            to: "news",
            smooth: true,
            offset: -120,
            className: "miyawaka-nav__list-item-link",
            children: "News"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "miyawaka-nav__list-item",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(modules/* Link */.rU, {
            to: "concept",
            smooth: true,
            offset: -120,
            className: "miyawaka-nav__list-item-link",
            children: "\u65BD\u8A2D\u7D39\u4ECB"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: "miyawaka-nav__list-item",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(modules/* Link */.rU, {
            to: "links",
            smooth: true,
            offset: -120,
            className: "miyawaka-nav__list-item-link",
            children: "\u5404\u7A2E\u30EA\u30F3\u30AF"
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Main, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "miyawaka-intro",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "miyawaka-intro__movie-block",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "miyawaka-intro__movie-item",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                className: "miyawaka-intro__movie",
                src: "https://www.youtube.com/embed/nHqTUbf_MXM",
                title: "YouTube video player",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: true
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "miyawaka-intro__movie-title",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "\u6B21\u4E16\u4EE3\u578B\u30B9\u30DE\u30FC\u30C8\u30B9\u30C8\u30A2TRIALGO"
              })
            })]
          })
        })
      }), topics !== null && topics !== void 0 && topics.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        id: "news",
        className: "miyawaka-news",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          titleText: "News",
          color: "normal"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "miyawaka-news__list",
          children: topics === null || topics === void 0 ? void 0 : topics.map(function (topic, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(TopicItem, {
              topic: topic
            }, index);
          })
        })]
      }) : '', /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        id: "concept",
        className: "miyawaka-concept",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          titleText: "\u65BD\u8A2D\u7D39\u4ECB",
          color: "normal"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 40,
            pc: 70
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
          className: "miyawaka-concept__block",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "miyawaka-concept__block-title-wrapper",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/remoteworktown_icon.png",
              alt: "\u30EA\u30E2\u30FC\u30C8\u30EF\u30FC\u30AF\u30BF\u30A6\u30F3",
              className: "miyawaka-concept__icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
              className: "miyawaka-concept__block-title",
              children: ["\u30EA\u30C6\u30FC\u30EBAI\u958B\u767A\u62E0\u70B9", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "miyawaka-concept__block-title-sub",
                children: "\uFF5E\u4E16\u754C\u4E2D\u304B\u3089\u7814\u7A76\u8005\u30FB\u6280\u8853\u8005\u304C\u96C6\u307E\u308B\u5834\u3078\u301C"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "miyawaka-three-column",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "miyawaka-three-column__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "miyawaka-three-column__img",
                src: "/images/remoteworktown_iotlob.png",
                alt: "TRIAL IoT Lab"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "miyawaka-three-column__title",
                children: "TRIAL IoT Lab"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text",
                children: "\u65E7\u5BAE\u7530\u897F\u4E2D\u5B66\u6821\u306E\u6821\u820E\u3092\u30EA\u30CE\u30D9\u30FC\u30B7\u30E7\u30F3\u3002\u6700\u5148\u7AEF\u306EIoT\u6280\u8853\u306E\u958B\u767A\u3001\u9AD8\u5EA6\u5316\u3092\u56F3\u308B\u5834\u6240\u3068\u3057\u3066\u3001\u30C7\u30D0\u30A4\u30B9\u958B\u767A\u30BB\u30F3\u30BF\u30FC\u306E\u6A5F\u80FD\u3092\u5099\u3048\u3066\u3044\u307E\u3059\u3002\u4ECA\u5F8C\u306F\u30C8\u30E9\u30A4\u30A2\u30EB\u3068\u304A\u53D6\u5F15\u306E\u3042\u308B\u30E1\u30FC\u30AB\u30FC\u306E\u30A8\u30F3\u30B8\u30CB\u30A2\u30E1\u30F3\u30D0\u30FC\u3082\u62DB\u8058\u3057\u3001\u30B9\u30DE\u30FC\u30C8\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8\u3092\u306F\u3058\u3081\u3001\u30EA\u30C6\u30FC\u30EB\u306E\u6280\u8853\u9769\u65B0\u3092\u9032\u3081\u3066\u6D41\u901A\u9769\u547D\u3092\u8D77\u3053\u3059\u62E0\u70B9\u3068\u306A\u3063\u3066\u3044\u304D\u307E\u3059\u3002"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "miyawaka-three-column__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "miyawaka-three-column__img",
                src: "/images/remoteworktown_musubuai.JPG",
                alt: "TRIAL MUSUBU AI"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "miyawaka-three-column__title",
                children: "MUSUBU AI"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text",
                children: "\u65E7\u5409\u5DDD\u5C0F\u5B66\u6821\u306E\u6821\u820E\u3092\u30EA\u30CE\u30D9\u30FC\u30B7\u30E7\u30F3\u3002AI\u7814\u7A76\u958B\u767A\u8005\u304C\u81EA\u7531\u304B\u3064\u5FEB\u9069\u306B\u7814\u7A76\u958B\u767A\u306B\u6253\u3061\u8FBC\u3081\u308B\u74B0\u5883\u3092\u6574\u3048\u307E\u3057\u305F\u3002\u307E\u305F\u3001\u30B5\u30C6\u30E9\u30A4\u30C8\u30AA\u30D5\u30A3\u30B9\u3084\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u30EB\u30FC\u30E0\u3092\u5099\u3048\u308B\u3053\u3068\u3067\u65E5\u672C\u4E2D\u306E\u307F\u306A\u3089\u305A\u4E16\u754C\u4E2D\u3068\u7E4B\u304E\u3001\u8DDD\u96E2\u306B\u3088\u308B\u969C\u58C1\u3092\u306A\u304F\u3057\u3066\u304A\u308A\u307E\u3059\u3002\u9996\u90FD\u570F\u3068\u4E16\u754C\u3092\u7E4B\u3050\u3001\u6280\u8853\u958B\u767A\u306E\u5F37\u529B\u306A\u5730\u5834\u3068\u306A\u3063\u3066\u3044\u307E\u3059\u3002\u4ECA\u5F8C\u306F\u201C\u77E5\u306E\u30AA\u30FC\u30D7\u30F3\u5316\u201D\u3001\u6559\u80B2\u6A5F\u95A2\u3068\u9023\u643A\u3057\u305F\u5C06\u6765\u306E\u7A2E\u6492\u304D\u3092\u884C\u3046\u65BD\u8A2D\u3068\u3057\u3066\u6D3B\u7528\u3044\u305F\u3057\u307E\u3059\u3002"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "miyawaka-three-column__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "miyawaka-three-column__img",
                src: "/images/remoteworktown_mediabase.jpg",
                alt: "TRIAL MEDIA BASE"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "miyawaka-three-column__title",
                children: "MEDIA BASE"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text",
                children: "\u65E7\u7B20\u677E\u5C0F\u5B66\u6821\u306E\u6821\u820E\u3092\u30EA\u30CE\u30D9\u30FC\u30B7\u30E7\u30F3\u3002\u30B7\u30E7\u30C3\u30D1\u30FC\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u5B9F\u73FE\u306E\u305F\u3081\u3001\u5E97\u982D\u306E\u30C7\u30B8\u30BF\u30EB\u30B5\u30A4\u30CD\u30FC\u30B8\u3067\u653E\u6620\u3057\u305F\u308ASNS\u3067\u4F7F\u7528\u3057\u305F\u308A\u3059\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u306E\u4F5C\u6210\u3084\u3001\u60C5\u5831\u767A\u4FE1\u3092\u304A\u3053\u306A\u3046\u57FA\u5730\u3067\u3059\u3002"
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
          className: "miyawaka-concept__block",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "miyawaka-concept__block-title-wrapper",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/remoteworktown_icon.png",
              alt: "\u30EA\u30E2\u30FC\u30C8\u30EF\u30FC\u30AF\u30BF\u30A6\u30F3",
              className: "miyawaka-concept__icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "miyawaka-concept__block-title",
              children: "\u5730\u57DF\u5171\u751F\u300C\u98DF\u300D\u300C\u4F4F\u300D\u6539\u9769"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "miyawaka-three-column",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "miyawaka-three-column__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "miyawaka-three-column__img",
                src: "/images/remoteworktown_groceria.JPG",
                alt: "TRIAL GROCERIA"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "miyawaka-three-column__title",
                children: "\u30B0\u30ED\u30C3\u30B5\u30EA\u30A2"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text-title",
                children: "\u798F\u5CA1\u30FB\u5BAE\u82E5\u3001\u305D\u3057\u3066\u4E5D\u5DDE\u306E\u5730\u57DF\u8272\u8C4A\u304B\u306A\u304A\u3044\u3057\u3055\u3068\u3068\u3082\u306B"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text",
                children: "\u300C\u30B0\u30ED\u30C3\u30B5\u30EA\u30A2\u300D\u3068\u306F\u3001\u305F\u3060\u98DF\u3079\u308B\u3060\u3051\u3067\u306A\u304F\u65B0\u305F\u306A\u98DF\u4E8B\u30B7\u30FC\u30F3\u3084\u98DF\u6587\u5316\u306E\u5275\u51FA\u306B\u3064\u306A\u304C\u308B\u5834\u3092\u63D0\u4F9B\u3059\u308B\u3001\u30B9\u30FC\u30D1\u30FC\u3068\u30B0\u30EB\u30E1\u30EC\u30B9\u30C8\u30E9\u30F3\u3092\u639B\u3051\u5408\u308F\u305B\u305F\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u65B0\u3057\u3044\u8907\u5408\u696D\u614B\u3067\u3059\u3002 \u300C\u30B0\u30ED\u30C3\u30B5\u30EA\u30A2\u300D\u306F\u3001\u98DF\u54C1\u3092\u610F\u5473\u3059\u308B\u300C\u30B0\u30ED\u30C3\u30B5\u30EA\u30FC\u300D\u3068\u3001\u30A4\u30BF\u30EA\u30A2\u306E\u5927\u8846\u98DF\u5802\u300C\u30C8\u30E9\u30C3\u30C8\u30EA\u30A2\u300D\u3092\u7D44\u307F\u5408\u308F\u305B\u305F\u9020\u8A9E\u3067\u3001\u98DF\u54C1\u30B9\u30FC\u30D1\u30FC\u3068\u3057\u3066\u306E\u30C8\u30E9\u30A4\u30A2\u30EB\u3092\u300C\u98DF\u300D\u3092\u8EF8\u306B\u767A\u5C55\u3055\u305B\u305F\u5E97\u8217\u3067\u3059\u3002\u5BAE\u82E5\u7523\u3092\u306F\u3058\u3081\u3068\u3059\u308B\u5730\u5143\u4E5D\u5DDE\u306E\u98DF\u6750\u3092\u6D3B\u304B\u3057\u305F\u5730\u7523\u5730\u6D88\u6599\u7406\u3092\u63D0\u4F9B\u3057\u3001\u30DF\u30B7\u30E5\u30E9\u30F3\u661F\u4ED8\u304D\u9AD8\u7D1A\u30D5\u30EC\u30F3\u30C1\u3067\u50CD\u3044\u305F\u30B7\u30A7\u30D5\u3084\u6771\u4EAC\u3067\u7D20\u6750\u306B\u3053\u3060\u308F\u3063\u305F\u8D85\u4EBA\u6C17\u30D9\u30FC\u30AB\u30EA\u30FC\u306E\u5143\u30C7\u30A3\u30EC\u30AF\u30BF\u30FC\u7B49\u3001\u4E00\u6D41\u6599\u7406\u4EBA\u304C\u76E3\u4FEE\u3057\u3066\u3044\u307E\u3059\u3002"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "miyawaka-three-column__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "miyawaka-three-column__img",
                src: "/images/remoteworktown_toranou.jpg",
                alt: "TRIAL TORANOU"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "miyawaka-three-column__title",
                children: "\u5BAE\u82E5\u864E\u306E\u6E6F"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text-title",
                children: "\u61D0\u304B\u3057\u3044\u98A8\u666F\u3068\u5730\u7523\u5730\u6D88\u30D3\u30E5\u30C3\u30D5\u30A7\u3067\u3082\u3066\u306A\u3059\u6E29\u6CC9\u65C5\u9928"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text",
                children: "2021\u5E7412\u6708\u3001\u8C4A\u304B\u306A\u81EA\u7136\u3068\u5B9F\u308A\u306E\u91CC\u30FB\u798F\u5CA1\u770C\u5BAE\u82E5\u5E02\u306E\u300C\u5BAE\u82E5\u6E29\u6CC9\u90F7\u300D\u5185\u306B\u8A95\u751F\u3057\u305F\u6E29\u6CC9\u65C5\u9928\u3067\u3059\u3002\u306E\u3069\u304B\u306A\u98A8\u666F\u306B\u56F2\u307E\u308C\u306A\u304C\u3089\u6E29\u6CC9\u3068\u30B0\u30EB\u30E1\u3067\u5FC3\u8EAB\u3092\u7652\u3084\u305B\u308B\u81F3\u798F\u306E\u5BBF\u3067\u3059\u3002\u5915\u98DF\u306F\u3001\u300CBuffet KOHAKU\u300D\u306B\u3066\u5730\u7523\u5730\u6D88\u306E\u98DF\u4E8B\u3092\u63D0\u4F9B\u3057\u3066\u3044\u307E\u3059\u3002\u90E8\u5C4B\u306F8\u30BF\u30A4\u30D7\u516844\u5BA4\u3067\u3001\u3059\u3079\u3066\u6E29\u6CC9\u98A8\u5442\u4ED8\u304D\u306E\u5BA2\u5BA4\u3068\u306A\u3063\u3066\u304A\u308A\u3001\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u306A\u9676\u5668\u98A8\u5442\u3084\u6A9C\u98A8\u5442\u3067\u5BBF\u81EA\u6162\u306E\u6E29\u6CC9\u3092\u72EC\u5360\u3067\u304D\u307E\u3059\u3002"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "miyawaka-three-column__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "miyawaka-three-column__img",
                src: "/images/remoteworktown_neri.jpg",
                alt: "TRIAL NERI"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "miyawaka-three-column__title",
                children: "\u53E4\u6C11\u5BB6\u300C\u7149\u308A\u300D"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text-title",
                children: "\u201C\u8C4A\u304B\u306A\u81EA\u7136\u3068\u5B9F\u308A\u306E\u91CC\u201D\u306B\u4F47\u3080\u51686\u68DF\u306E\u96E2\u308C\u306E\u5BBF"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "miyawaka-three-column__text",
                children: ["\u6E29\u6CC9\u4ED8\u304D\u306E\u53E4\u6C11\u5BB6\u306E\u96E2\u308C\u3092\u72EC\u308A\u5360\u3081\u3059\u308B\u6E29\u6CC9\u5BBF\u3067\u30012021\u5E747\u6708\u306B\u30AA\u30FC\u30D7\u30F3\u3057\u307E\u3057\u305F\u3002\u65C5\u9928\u6587\u5316\u3092\u6B21\u306E\u4E16\u4EE3\u3078\u3068\u3064\u306A\u3052\u3066\u304D\u305F\u5148\u4EBA\u3078\u306E\u611F\u8B1D\u3068\u656C\u610F\u3092\u5FD8\u308C\u305A\u3001\u4E00\u65E5\u4E00\u65E5\u3001\u30B2\u30B9\u30C8\u3092\u5927\u5207\u306B\u51FA\u8FCE\u3048\u3001\u201C\u7B2C\u4E8C\u306E\u6545\u90F7\u201D\u3068\u306A\u308B\u3088\u3046\u3001\u6E29\u304B\u304F\u7D30\u3084\u304B\u306A\u5FC3\u9063\u3044\u3067\u3082\u3066\u306A\u3059\u306E\u304C\u300C\u53E4\u6C11\u5BB6 \u7149\u308A\u300D\u306E\u4FE1\u6761\u3067\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u53E4\u6C11\u5BB6\u306E\u6E29\u6CC9\u4ED8\u304D\u306E\u96E2\u308C\u3067\u3001\u6B62\u307E\u308B\u6642\u9593\u3001\u3055\u304B\u306E\u307C\u308B\u3072\u3068\u3068\u304D\u3001\u601D\u3044\u51FA\u3059\u5FC3\u306E\u5C45\u5FC3\u5730\u3092\u611F\u53D7\u3057\u3001\u5927\u5207\u306A\u4EBA\u3068\u6155\u308F\u3057\u3044\u61A9\u3044\u306B\u6D78\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "miyawaka-three-column",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "miyawaka-three-column__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "miyawaka-three-column__img",
                src: "/images/remoteworktown_kohaku.jpg",
                alt: "TRIAL KOHAKU"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "miyawaka-three-column__title",
                children: "\u6599\u5320\u864E\u767D"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text-title",
                children: "\u81EA\u7136\u3068\u5065\u5EB7\u3092\u8003\u3048\u305F\u61D0\u77F3\u6599\u7406\u3092\u6975\u3081\u308B"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "miyawaka-three-column__text",
                children: ["\u7D4C\u9A13\u8C4A\u5BCC\u306A\u6599\u7406\u4EBA\u304C\u3001\u5730\u57DF\u3067\u80B2\u3063\u305F\u65B0\u9BAE\u3067\u5B89\u5FC3\u306E\u98DF\u6750\u306B\u3053\u3060\u308F\u308A\u3001\u4F1D\u7D71\u3092\u5927\u5207\u306B\u3057\u306A\u304C\u3089\u3082\u4ECA\u3092\u611F\u3058\u308B\u6599\u7406\u3092\u63D0\u4F9B\u3057\u3066\u3044\u307E\u3059\u3002\u5730\u5143\u30FB\u798F\u5CA1\u306E\u98A8\u571F\u3084\u7F8E\u5473\u3057\u3044\u6E67\u304D\u6C34\u3001\u76C6\u5730\u306E\u5BD2\u6696\u5DEE\u304C\u80B2\u3066\u305F\u6570\u3005\u306E\u91CE\u83DC\u3001\u8FD1\u304F\u306E\u6F01\u6E2F\u3067\u6C34\u63DA\u3052\u3055\u308C\u305F\u65B0\u9BAE\u306A\u6D77\u306E\u5E78\u3092\u4E2D\u5FC3\u306B\u3001\u4EBA\u304C\u81EA\u7136\u3068\u7B11\u9854\u306B\u306A\u308B\u3088\u3046\u306A\u6599\u7406\u3092\u5FC3\u304C\u3051\u3066\u3044\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u6614\u306A\u304C\u3089\u306E\u304B\u307E\u3069\u306E\u4F7F\u7528\u306A\u3069\u6599\u7406\u306B\u5408\u308F\u305B\u305F\u8ABF\u7406\u904E\u7A0B\u306B\u3082\u3053\u3060\u308F\u308A\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u540C\u6577\u5730\u5185\u306B\u3042\u308B\u300C\u53E4\u6C11\u5BB6\u7149\u308A\u300D\u306E\u5BBF\u6CCA\u8005\u306F\u671D\u98DF\u3082\u697D\u3057\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "miyawaka-three-column__item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: "miyawaka-three-column__img",
                src: "/images/remoteworktown_soukatei.jpg",
                alt: "TRIAL SAUKATEI"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "miyawaka-three-column__title",
                children: "\u98AF\u9999\u4EAD"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "miyawaka-three-column__text-title",
                children: "\u5BAE\u82E5\u3001\u798F\u5CA1\u305D\u3057\u3066\u4E5D\u5DDE\u98A8\u571F\u306E\u6069\u6075\u3092\u6ECB\u5473\u6DF1\u3044\u5473\u308F\u3044\u3078"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                className: "miyawaka-three-column__text",
                children: ["\u300C\u30DF\u30B7\u30E5\u30E9\u30F3\u30AC\u30A4\u30C9\u798F\u5CA12019\u300D\u306E1\u3064\u661F\u306B\u9078\u3070\u308C\u305F\u30D5\u30EC\u30F3\u30C1\u300C\u98AF\u9999\u4EAD\u300D\u3067\u306F\u3001\u751F\u7523\u8005\u304B\u3089\u76F4\u306B\u4ED5\u5165\u308C\u308B\u98DF\u6750\u3092\u4F7F\u3063\u305F\u201C\u81EA\u7136\u201D\u304C\u30E2\u30C1\u30FC\u30D5\u306E\u6599\u7406\u3092\u3001\u3054\u8981\u671B\u3084\u3054\u4E88\u7B97\u306B\u5FDC\u3058\u305F\u201C\u30AA\u30FC\u30C8\u30AF\u30C1\u30E5\u30FC\u30EB\u201D\u306A\u30C7\u30A3\u30CA\u30FC\u30B3\u30FC\u30B9\u3067\u63D0\u4F9B\u3057\u3066\u3044\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u300C\u98AF\u9999\u4EAD\u300D\u306B\u306F\u6C7A\u307E\u3063\u305F\u30E1\u30CB\u30E5\u30FC\u306F\u306A\u304F\u3001\u7D20\u6750\u306E\u58F0\u306B\u8033\u3092\u50BE\u3051\u3001\u53D7\u3051\u53D6\u3063\u305F\u30A4\u30F3\u30B9\u30D4\u30EC\u30FC\u30B7\u30E7\u30F3\u3092\u6599\u7406\u3068\u3057\u3066\u5177\u73FE\u5316\u3057\u3066\u3044\u307E\u3059\u3002"]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "miyawaka-facility__img",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/images/remoteworktown_map.png",
              alt: "\u5BAE\u82E5\u5E02\u5168\u57DF\u56F3"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "facility-table-wrapper",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "facility-table-scroll-hint",
              children: "\u203B\u6A2A\u30B9\u30AF\u30ED\u30FC\u30EB\u3067\u304D\u307E\u3059"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
              className: "facility-table",
              cellSpacing: "0",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                    className: "facility-table__head",
                    children: "\u3053\u308C\u307E\u3067"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                    className: "facility-table__head",
                    children: "\u3053\u308C\u304B\u3089"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                    className: "facility-table__head",
                    children: "\u7A3C\u50CD\u958B\u59CB\u6642\u671F"
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__number1",
                    children: "\u65E7 \u5409\u5DDD\u5C0F\u5B66\u6821\u6821\u820E"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["MUSUBU AI", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "facility-table__data--small",
                      children: "\uFF08AI\u958B\u767A\u30BB\u30F3\u30BF\u30FC\uFF09"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2021\u5E746\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__number2",
                    children: "\u65E7 \u5409\u5DDD\u5C0F\u5B66\u6821\u4F53\u80B2\u9928"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["\u30B0\u30ED\u30C3\u30B5\u30EA\u30A2", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "facility-table__data--small",
                      children: "\uFF08\u8FB2\u5712\u30EC\u30B9\u30C8\u30E9\u30F3\uFF09"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2022\u5E744\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__number3",
                    children: "\u65E7 \u5409\u5DDD\u5C0F\u5B66\u6821\u904B\u52D5\u5834"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["TRIAL GO\u8107\u7530\u5E97", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "in \u307F\u3084\u308F\u304B\u306E\u90F7"]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2022\u5E744\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__number4",
                    rowSpan: 4,
                    children: "\u65E7 \u30B9\u30B3\u30FC\u30EC\u82E5\u5BAE"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["\u5BAE\u82E5\u864E\u306E\u6E6F", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "facility-table__data--small",
                      children: "\uFF08MUSUBU\u5BAE\u82E5\u6E29\u6CC9\u90F7\uFF09"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2021\u5E7412\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["\u53E4\u6C11\u5BB6 \u7149\u308A", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "facility-table__data--small",
                      children: "\uFF08MUSUBU\u5BAE\u82E5\u6E29\u6CC9\u90F7\uFF09"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2021\u5E747\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["\u98AF\u9999\u4EAD", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "facility-table__data--small",
                      children: "\uFF08MUSUBU\u5BAE\u82E5\u6E29\u6CC9\u90F7\uFF09"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2021\u5E747\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["\u6599\u5320\u864E\u767D", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "facility-table__data--small",
                      children: "\uFF08MUSUBU\u5BAE\u82E5\u6E29\u6CC9\u90F7\uFF09"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2021\u5E747\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__number5",
                    children: "\u65E7 \u5BAE\u7530\u897F\u4E2D\u5B66\u6821"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["TRIAL IoT Lab", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "facility-table__data--small",
                      children: "\uFF08AI\u30C7\u30D0\u30A4\u30B9\u958B\u767A\u30BB\u30F3\u30BF\u30FC\uFF09"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2021\u5E747\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__number6",
                    children: "\u65E7 \u7B20\u677E\u5C0F\u5B66\u6821"
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["MEDIA BASE", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "facility-table__data--small",
                      children: ["(\u30B9\u30DE\u30FC\u30C8\u30B9\u30C8\u30A2\u306E", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30E1\u30C7\u30A3\u30A2\u30B3\u30F3\u30C6\u30F3\u30C4\u4F5C\u6210)"]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2021\u5E747\u6708"
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  className: "facility-table__row",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__number7",
                    children: ["\u65E7 \u5BAE\u7530", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30BB\u30F3\u30BF\u30FC"]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                    className: "facility-table__data",
                    children: ["\u30B9\u30FC\u30D1\u30FC\u30BB\u30F3\u30BF\u30FC", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u30C8\u30E9\u30A4\u30A2\u30EB\u5BAE\u7530\u5E97"]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                    className: "facility-table__data",
                    children: "2021\u5E7410\u6708"
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("tfoot", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                    className: "facility-table__foot",
                    children: "\u3053\u308C\u307E\u3067"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                    className: "facility-table__foot",
                    children: "\u3053\u308C\u304B\u3089"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                    className: "facility-table__foot",
                    children: "\u7A3C\u50CD\u958B\u59CB\u6642\u671F"
                  })]
                })
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
        id: "links",
        className: "miyawaka-links",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          titleText: "\u5404\u7A2E\u30EA\u30F3\u30AF",
          color: "normal"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "miyawaka-links__main",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "miyawaka-links__link-item",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.city.miyawaka.lg.jp/",
              target: "_blank",
              rel: "noreferrer noopener",
              className: "miyawaka-links__img-link",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/images/remoteworktown_miyawaka_logo.png",
                alt: "\u5BAE\u82E5\u5E02",
                className: "miyawaka-links__img"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.city.miyawaka.lg.jp/",
              target: "_blank",
              rel: "noreferrer noopener",
              className: "miyawaka-links__link",
              children: "\u5BAE\u82E5\u5E02"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "miyawaka-links__link-item",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.kyushu-u.ac.jp/ja/",
              target: "_blank",
              rel: "noreferrer noopener",
              className: "miyawaka-links__img-link",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/images/remoteworktown_kyusyu_university_logo.png",
                alt: "\u4E5D\u5DDE\u5927\u5B66",
                className: "miyawaka-links__img"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://www.kyushu-u.ac.jp/ja/",
              target: "_blank",
              rel: "noreferrer noopener",
              className: "miyawaka-links__link",
              children: "\u4E5D\u5DDE\u5927\u5B66"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
          className: "miyawaka-links__group",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: "miyawaka-links__group-title",
            children: "\u5BBF\u6CCA\u30FB\u98F2\u98DF\u65BD\u8A2D\u95A2\u9023"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "miyawaka-links__group-link-list",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "miyawaka-links__group-link-item",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://groceria.jp/",
                target: "_blank",
                rel: "noreferrer noopener",
                className: "miyawaka-links__group-link",
                children: "\u30B0\u30ED\u30C3\u30B5\u30EA\u30A2"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "miyawaka-links__group-link-item",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://miyawaka-toranoyu.com/",
                target: "_blank",
                rel: "noreferrer noopener",
                className: "miyawaka-links__group-link",
                children: "\u5BAE\u82E5\u864E\u306E\u6E6F"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "miyawaka-links__group-link-item",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://kominka-neri.com/",
                target: "_blank",
                rel: "noreferrer noopener",
                className: "miyawaka-links__group-link",
                children: "\u53E4\u6C11\u5BB6 \u7149\u308A"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "miyawaka-links__group-link-item",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://ryosho-kohaku.com/",
                target: "_blank",
                rel: "noreferrer noopener",
                className: "miyawaka-links__group-link",
                children: "\u6599\u5320 \u864E\u767D"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "miyawaka-links__group-link-item",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://info-soukatei.com/",
                target: "_blank",
                rel: "noreferrer noopener",
                className: "miyawaka-links__group-link",
                children: "\u98AF\u9999\u4EAD"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "miyawaka-links__group-link-item",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "https://miyawaka-onsenkyo.com/",
                target: "_blank",
                rel: "noreferrer noopener",
                className: "miyawaka-links__group-link",
                children: "\u5BAE\u82E5\u6E29\u6CC9\u90F7"
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "miyawaka-conclusion",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "miyawaka-conclusion__img",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "/images/remoteworktown_msg2.png",
            alt: "\u5909\u3048\u308B\u306A\u3089\u3001\u4E16\u754C\u3054\u3068\u3002\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7"
          })
        })
      })]
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/pages/Remoteworktown/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var RemoteworktownPage = function RemoteworktownPage(_ref) {
  var topics = _ref.topics;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(RemoteworktownMain, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Detailed, {
      topics: topics
    })
  });
};
var pageTitle = {
  title: 'REMOTEWORK TOWN',
  subTitle: 'リモートワークタウン ムスブ宮若'
};

RemoteworktownPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: 'リモートワークタウン ムスブ宮若',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u30EA\u30E2\u30FC\u30C8\u30EF\u30FC\u30AF\u30BF\u30A6\u30F3 \u30E0\u30B9\u30D6\u5BAE\u82E5",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u4F01\u696D\u60C5\u5831\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: '/Remoteworktown/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
      breadCrumbs: breadCrumbs,
      children: page
    }))]
  });
};

var RemoteworktownMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Remoteworktown__RemoteworktownMain",
  componentId: "sc-1owgh3s-0"
})(["width:1040px;margin:0 auto;padding:98px 0 130px;@media screen and (max-width:1047px){width:100%;padding:0 20px 70px;}"]);
;// CONCATENATED MODULE: ./src/pages/remoteworktown/index.tsx
var __N_SSG = true;


/***/ }),

/***/ 488:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remoteworktown",
      function () {
        return __webpack_require__(42862);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,5548,9774,2888,179], function() { return __webpack_exec__(488); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);